import {useMemo} from "react";
import SelectInput from "../index";
import useQueryString from "../../../../hooks/useQueryString";

const CategorySelectInput = ({categoryType, ...rest}) => {
    const {queryStringFN} = useQueryString();
    const {data} = [];

    const memoType = useMemo(() => [], [data]);

    return (
        <SelectInput
            data={memoType}
            onChange={(item) => {
                if (item) queryStringFN.set("category", item.id);
                else queryStringFN.remove("category");
            }}
            {...rest}
        />
    );
};

export default CategorySelectInput;
